/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TRegion_metaModel,
  IRegion_metaRequest,
  IMappers,
  IRegion_metaResponse,
  IRegion_metaResponseInternalServerError,
  IRegion_metaResponseError,
  TRegion_metaResponse,
} from './types';

const defaultConfig: TRegion_metaModel = {
  apiType: 'legacy',
  assertStatusCodes: [200, 500, 400],
  method: 'GET',
  microserviceName: 'monolith-python',
  pathApi: '/cian-api/mobile-site/v1/region_meta/',
  hostType: 'api',
} as TRegion_metaModel;

function createRegion_metaModel(parameters: IRegion_metaRequest): TRegion_metaModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IRegion_metaOptions<TResponse200, TResponse500, TResponse400> {
  httpApi: IHttpApi;
  parameters: IRegion_metaRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse500, TResponse400>;
}

async function fetchRegion_meta<TResponse200, TResponse500, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IRegion_metaOptions<TResponse200, TResponse500, TResponse400>): Promise<
  TResponse200 | TResponse500 | TResponse400 | TRegion_metaResponse
> {
  const { response, statusCode } = await httpApi.fetch(createRegion_metaModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IRegion_metaResponse);
    }

    if (statusCode === 500) {
      return mappers[500](response as IRegion_metaResponseInternalServerError);
    }

    if (statusCode === 400) {
      return mappers[400](response as IRegion_metaResponseError);
    }
  }

  return { response, statusCode } as TRegion_metaResponse;
}

export { defaultConfig, createRegion_metaModel, fetchRegion_meta };
